// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProductReport":"eo_a bih_a bih_x bih_j bih_u bih_bc bih_ql bih_vv"};